module.exports = "/password-aedab9427a3940a1aa974fe33c26a5ce.svg";